// extracted by mini-css-extract-plugin
export default {"tokensContainer":"TokenDetails_tokensContainer__V7e+7","reloadButtonContainer":"TokenDetails_reloadButtonContainer__iN8zZ"};